var map = {
	"./amwal-checkout-button_4.entry.js": [
		32960,
		4408,
		2960
	],
	"./ion-accordion-group.entry.js": [
		94648,
		4648
	],
	"./ion-accordion.entry.js": [
		19134,
		9134
	],
	"./ion-action-sheet_3.entry.js": [
		79684,
		7774,
		4408,
		4123
	],
	"./ion-app.entry.js": [
		87255,
		7255
	],
	"./ion-avatar.entry.js": [
		83043,
		3043
	],
	"./ion-back-button.entry.js": [
		17974,
		7974
	],
	"./ion-backdrop.entry.js": [
		5404,
		5404
	],
	"./ion-badge.entry.js": [
		80459,
		459
	],
	"./ion-breadcrumb.entry.js": [
		14519,
		4519
	],
	"./ion-breadcrumbs.entry.js": [
		17682,
		7682
	],
	"./ion-buttons_3.entry.js": [
		40603,
		603
	],
	"./ion-card-content.entry.js": [
		42696,
		2696
	],
	"./ion-card-header.entry.js": [
		70040,
		40
	],
	"./ion-card-subtitle.entry.js": [
		7165,
		7165
	],
	"./ion-card-title.entry.js": [
		56639,
		6639
	],
	"./ion-card.entry.js": [
		63072,
		3072
	],
	"./ion-checkbox_7.entry.js": [
		77097,
		7097
	],
	"./ion-chip.entry.js": [
		64604,
		4604
	],
	"./ion-col.entry.js": [
		85838,
		5838
	],
	"./ion-content.entry.js": [
		85381,
		5381
	],
	"./ion-datetime-button.entry.js": [
		6896,
		8189,
		6896
	],
	"./ion-datetime.entry.js": [
		73015,
		8189,
		3015
	],
	"./ion-fab-button.entry.js": [
		14194,
		4194
	],
	"./ion-fab-list.entry.js": [
		34138,
		4138
	],
	"./ion-fab.entry.js": [
		67873,
		7873
	],
	"./ion-footer.entry.js": [
		65985,
		2574,
		5985
	],
	"./ion-grid.entry.js": [
		89034,
		9034
	],
	"./ion-header.entry.js": [
		29035,
		2574,
		9035
	],
	"./ion-icon.entry.js": [
		44923,
		4923
	],
	"./ion-img.entry.js": [
		55219,
		5219
	],
	"./ion-infinite-scroll-content.entry.js": [
		48970,
		8970
	],
	"./ion-infinite-scroll.entry.js": [
		898,
		2574,
		898
	],
	"./ion-input.entry.js": [
		60852,
		2930,
		852
	],
	"./ion-item-divider.entry.js": [
		2217,
		2217
	],
	"./ion-item-group.entry.js": [
		6571,
		6571
	],
	"./ion-item-option.entry.js": [
		41015,
		1015
	],
	"./ion-item-options.entry.js": [
		2162,
		2162
	],
	"./ion-item-sliding.entry.js": [
		3138,
		2574,
		3138
	],
	"./ion-loading.entry.js": [
		99824,
		7774,
		4408,
		5069
	],
	"./ion-menu-button.entry.js": [
		67614,
		7774,
		1889,
		1667
	],
	"./ion-menu-toggle.entry.js": [
		50450,
		7774,
		1889,
		387
	],
	"./ion-menu.entry.js": [
		94805,
		7774,
		4408,
		1889,
		6218
	],
	"./ion-modal.entry.js": [
		68389,
		7774,
		2574,
		4408,
		8389
	],
	"./ion-nav-link.entry.js": [
		9258,
		9258
	],
	"./ion-nav.entry.js": [
		2381,
		2381
	],
	"./ion-note.entry.js": [
		52894,
		2894
	],
	"./ion-picker-column.entry.js": [
		63495,
		3495
	],
	"./ion-picker.entry.js": [
		44356,
		7774,
		4408,
		3051
	],
	"./ion-popover.entry.js": [
		23645,
		7774,
		4408,
		3645
	],
	"./ion-progress-bar.entry.js": [
		49853,
		9853
	],
	"./ion-range.entry.js": [
		4897,
		2574,
		4897
	],
	"./ion-refresher-content.entry.js": [
		73028,
		3028
	],
	"./ion-refresher.entry.js": [
		81524,
		7774,
		2574,
		1524
	],
	"./ion-reorder-group.entry.js": [
		63581,
		2574,
		3581
	],
	"./ion-reorder.entry.js": [
		53475,
		3475
	],
	"./ion-route-redirect.entry.js": [
		53178,
		3178
	],
	"./ion-route.entry.js": [
		8105,
		8105
	],
	"./ion-router-link.entry.js": [
		87392,
		7392
	],
	"./ion-router-outlet.entry.js": [
		71901,
		1901
	],
	"./ion-router.entry.js": [
		94535,
		4535
	],
	"./ion-row.entry.js": [
		3676,
		3676
	],
	"./ion-searchbar.entry.js": [
		70933,
		933
	],
	"./ion-segment-button.entry.js": [
		88278,
		8278
	],
	"./ion-segment.entry.js": [
		2605,
		2605
	],
	"./ion-select-option.entry.js": [
		76658,
		6658
	],
	"./ion-select.entry.js": [
		51582,
		4408,
		2930,
		1582
	],
	"./ion-skeleton-text.entry.js": [
		96789,
		6789
	],
	"./ion-spinner.entry.js": [
		61094,
		8713
	],
	"./ion-split-pane.entry.js": [
		14267,
		4267
	],
	"./ion-tab-bar.entry.js": [
		12291,
		2291
	],
	"./ion-tab-button.entry.js": [
		50004,
		4
	],
	"./ion-tab.entry.js": [
		29219,
		9219
	],
	"./ion-tabs.entry.js": [
		58262,
		8262
	],
	"./ion-textarea.entry.js": [
		94448,
		2930,
		4448
	],
	"./ion-thumbnail.entry.js": [
		13708,
		3708
	],
	"./ion-title.entry.js": [
		17086,
		7086
	],
	"./ion-toast.entry.js": [
		18035,
		7774,
		4408,
		8035
	],
	"./ion-toggle.entry.js": [
		36042,
		6042
	],
	"./ion-toolbar.entry.js": [
		60859,
		859
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21016;
module.exports = webpackAsyncContext;